let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1KVRQ")).then(() => parcelRequire('1QmuW'));